import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck, Clock } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full min-h-[calc(100vh-60px)] md:min-h-[calc(100vh-80px)] flex items-center justify-center overflow-hidden" data-id="element-99">
      {/* Parallax Background */}
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&q=80')] bg-cover bg-center bg-fixed" aria-hidden="true" data-id="element-100" />

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/65" aria-hidden="true" data-id="element-101" />

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 md:px-6 py-20 flex flex-col items-center text-center" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-4xl" data-id="element-103">
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-extrabold text-white tracking-tight leading-[1.1] mb-6" style={{
          textShadow: '0 2px 20px rgba(0,0,0,0.7)'
        }} data-id="element-104">
            Transform Your Space. <br className="hidden md:block" data-id="element-105" />
            <span className="text-warmWhite" data-id="element-106">Elevate Your Home.</span>
          </h1>

          <p className="text-lg md:text-xl text-warmWhite/90 mb-10 max-w-2xl mx-auto font-light leading-relaxed" data-id="element-107">
            Expert painting and remodeling services that bring your vision to
            life. Quality craftsmanship for the modern homeowner.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12" data-id="element-108">
            <a href="#contact" className="w-full sm:w-auto bg-gold text-charcoal px-8 py-4 rounded font-semibold text-base md:text-lg hover:bg-gold/90 transition-colors shadow-lg" data-id="element-109">
              Get a Free Estimate
            </a>
            <a href="#portfolio" className="w-full sm:w-auto bg-transparent border-2 border-white text-white px-8 py-4 rounded font-semibold text-base md:text-lg hover:bg-white/10 transition-colors" data-id="element-110">
              View Our Work
            </a>
          </div>

          {/* Trust Strip */}
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm md:text-base text-warmWhite/80 font-medium" data-id="element-111">
            <div className="flex items-center gap-2" data-id="element-112">
              <ShieldCheck className="w-5 h-5 text-gold" data-id="element-113" />
              <span data-id="element-114">Licensed & Insured</span>
            </div>
            <div className="hidden sm:block w-1.5 h-1.5 rounded-full bg-gold/50" data-id="element-115" />
            <div className="flex items-center gap-2" data-id="element-116">
              <Star className="w-5 h-5 text-gold fill-gold" data-id="element-117" />
              <span data-id="element-118">5-Star Rated</span>
            </div>
            <div className="hidden sm:block w-1.5 h-1.5 rounded-full bg-gold/50" data-id="element-119" />
            <div className="flex items-center gap-2" data-id="element-120">
              <Clock className="w-5 h-5 text-gold" data-id="element-121" />
              <span data-id="element-122">Free Estimates</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}